import React, { createContext, useState, useEffect } from 'react';

// Context holds currency and workspace (ws) ID
export const SessionContext = createContext({
  session: { currency: 'eur', ws: null },
  setSession: () => {}
});

export function SessionProvider({ children }) {
  // Initialize from sessionStorage if available, with JSON parse safety
  const [session, setSession] = useState(() => {
    const stored = sessionStorage.getItem('campSession');
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (err) {
        console.warn('Failed parsing sessionStorage, resetting:', err);
        sessionStorage.removeItem('campSession');
      }
    }
    return { currency: 'eur', ws: null };
  });

  // Persist session state to sessionStorage on every change
  useEffect(() => {
    try {
      sessionStorage.setItem('campSession', JSON.stringify(session));
    } catch (err) {
      console.error('Failed writing sessionStorage:', err);
    }
  }, [session]);

  // On mount, extract ws from query string (?ws=123) or legacy /ws-123 in the path
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const wsFromQuery = params.get('ws');

    let wsValue = null;
    if (wsFromQuery && /^\d+$/.test(wsFromQuery)) {
      wsValue = wsFromQuery;
    } else {
      const path = window.location.pathname;
      const match = path.match(/\/ws-(\d+)(?:\/|$)/);
      if (match) wsValue = match[1];
    }

    if (wsValue) {
      setSession(prev => (prev.ws === wsValue ? prev : { ...prev, ws: wsValue }));

      // Optional: tidy the URL by removing ?ws=... after capturing (no reload)
      if (wsFromQuery) {
        const url = new URL(window.location.href);
        url.searchParams.delete('ws');
        window.history.replaceState({}, '', url.toString());
      }
    }
  }, []);

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
}
